import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const wpcf7Elm = this.el.querySelector('.wpcf7');
        const success = this.el.querySelector('.c-form_success');

        if (!wpcf7Elm) {
            return;
        }

        const form = wpcf7Elm.querySelector('form');
        if (form && typeof window.wpcf7 !== 'undefined' && typeof window.wpcf7.init === 'function') {
            window.wpcf7.init(form);
        }

        const params = new URLSearchParams(window.location.search);
        const service = params.get('service');
        if (service) {
            const field = this.el.querySelector('input[name="service"]');
            if (field) field.value = 'Service d\'origine : ' + decodeURIComponent(service.replace(/\+/g, ' '));
        }

        const unlockForm = () => {
            form?.classList.remove('submitting');
        };

        ['wpcf7invalid', 'wpcf7mailfailed', 'wpcf7spam', 'wpcf7mailsent', 'wpcf7submit'].forEach((eventName) => {
            wpcf7Elm.addEventListener(eventName, unlockForm);
        });

        wpcf7Elm.addEventListener('wpcf7mailsent', () => {
            wpcf7Elm.classList.add('-sent');
            if (success) {
                success.classList.add('-visible');
            }
            this.call('scrollTop', 'Scroll');
            setTimeout(() => {
                this.call('setLight', 'Navbar');
            }, 300);
        });
    }
}
